import { FC } from 'react';

import { myXp } from 'app/data/experience';
import { ExperienceView } from './experience-view/ExperienceView';
import { SeparatedList } from 'app/components/separated-list/SeparatedList';
import { AppText } from 'app/components/app-text/AppText';

export const ExperienceMobile: FC = () => {
  return (
    <>
      <AppText>13 years in total</AppText>
      <hr className='my-4' />
      <SeparatedList
        data={myXp}
        renderItem={xp => <ExperienceView value={xp} />}
      />
    </>
  );
};
